import { createContext } from 'react';
import { MapService } from 'app/map/services/map.service';
import { AssetCollection } from 'app/shared/collections/asset_collection.service';
import { AssetTypeCollection } from 'app/shared/collections/asset_type_collection.service';
import { TerrainService } from 'app/map/services/terrain.service';
import { MapInputHandlerService } from 'app/map/services/map_input_handling/MapInputHandlerService';
import { SelectionService } from 'app/shared/selection/SelectionService';
import { AgricultureToastService } from 'app/agriculture/AgricultureToast/agriculture_toast_service';
import { StartupRegistry } from 'app/startup/registry/registry';
import { CesiumMap } from 'app/map/map';
import { ScaleIndicator } from 'app/agriculture/AgricultureMap/components/ScaleIndicator/ScaleIndicator.service';
import { SnappingService } from 'app/agriculture/cesium/snapping/snapping_service';
import { ImsObjectVisibilityService } from 'app/shared/visibility/ImsObjectVisibilityService';
import { AgPanelService } from 'app/agriculture/entities/ag_panel_service';

export interface Services {
    agPanelService: AgPanelService;
    agricultureToastService: AgricultureToastService;
    assetCollection: AssetCollection;
    assetTypeCollection: AssetTypeCollection;
    cesiumMap: CesiumMap;
    imsObjectVisibilityService: ImsObjectVisibilityService;
    mapInputHandlerService: MapInputHandlerService;
    mapService: MapService;
    scaleIndicator: ScaleIndicator;
    selectionService: SelectionService;
    snappingService: SnappingService;
    stage2StartUpRegistry: StartupRegistry;
    terrainService: TerrainService;
}

export const ServicesContext = createContext({} as Services);
